import { useState } from 'react';
import ButtonElement from '@/components/elements/Button/Button';

const MAP_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.071834163048!2d85.2975386!3d27.6841746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb196a27a33541%3A0x6f2ba68dd5c4ed69!2sYuki%20Enterprises%20Pvt%20Ltd!5e0!3m2!1sen!2snp!4v1705600583898!5m2!1sen!2snp';
const MAP_LINK = 'https://www.google.com/maps/search/?api=1&query=27.6841746,85.2975386';

/**
 * Google Map that only loads when the visitor asks for it.
 *
 * Embedding the map straight away contacts Google (and lets it set cookies) for every
 * visitor who merely opens the page. Until the button is pressed nothing is requested
 * from Google, so the site stays free of third-party calls unless the visitor opts in.
 */
const MapEmbed = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative h-full min-h-[300px] w-full overflow-hidden rounded-lg bg-slate-200">
      {loaded ? (
        <iframe
          title="Our location on Google Maps"
          src={MAP_EMBED_URL}
          className="absolute inset-0 h-full w-full border-0"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-6 text-center">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className="h-10 w-10 text-custom-secolor"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z" />
            <circle cx="12" cy="9.5" r="2.5" />
          </svg>
          <p className="font-semibold text-custom-darkblue">Find us on the map</p>
          <p className="max-w-xs text-sm text-gray-600">
            The map is provided by Google. It loads only when you choose to show it, and Google may
            set cookies once it does.
          </p>
          <ButtonElement btnText="Show map" size="small" onClick={() => setLoaded(true)} />
          <a
            href={MAP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-custom-secolor underline"
          >
            Open in Google Maps
          </a>
        </div>
      )}
    </div>
  );
};

export default MapEmbed;
